import { createFileRoute } from '@tanstack/react-router'

import { SourceHealthScreen } from '@/features/sourcing/source-health-screen'
import { sourceHealthSearchSchema } from '@/features/sourcing/source-health-search'

/** Whether the market sources are answering, and how much budget is left; the tab is in the address. */
export const Route = createFileRoute('/_app/platform/source-health')({
  validateSearch: sourceHealthSearchSchema,
  component: SourceHealthScreen,
})
